module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"recent_events":"Recent events","show_more":"Show more","show_less":"Show less","request":{"recent_events":"Something went wrong while trying to get recent events."}},"ko":{"recent_events":"최근 내역","show_more":null,"show_less":null,"request":{"recent_events":null}}}')
  delete Component.options._Ctor
}
